// ═══════════════════════════════════════════════════════════════
// MEDIA CARD
// ═══════════════════════════════════════════════════════════════
import { useState} from "react";
import { formatBytes, formatDuration } from "./Utility";
import { Icons } from "./Icons";

export function MediaCard({ item, isSelected, onSelect, onDelete }) {
  const [hovering, setHovering] = useState(false);

  const thumbSrc =
    item.type === "image"
      ? item.dataUrl
      : item.type === "video"
      ? item.thumbnail
      : null;

  return (
    <div
      onClick={() => onSelect(item.id)}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      style={{
        position: "relative",
        borderRadius: "8px",
        overflow: "hidden",
        cursor: "pointer",
        aspectRatio: "1",
        background: "#f3f4f6",
        border: isSelected ? "2.5px solid #7c3aed" : "2.5px solid transparent",
        transition: "border-color 0.15s, transform 0.15s, box-shadow 0.15s",
        transform: isSelected ? "scale(0.97)" : hovering ? "scale(0.98)" : "scale(1)",
        boxShadow: isSelected
          ? "0 0 0 2px rgba(124,58,237,0.18)"
          : hovering
          ? "0 4px 16px rgba(0,0,0,0.08)"
          : "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      {thumbSrc ? (
        <img
          src={thumbSrc}
          alt={item.name}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#f9fafb",
            padding: "12px",
          }}
        >
          <div style={{ color: "#ef4444", marginBottom: 6 }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
          </div>
          <span style={{ fontSize: "10px", color: "#6b7280", textAlign: "center", wordBreak: "break-all", lineHeight: 1.3, maxHeight: "2.6em", overflow: "hidden" }}>
            {item.name}
          </span>
          <span style={{ fontSize: "11px", fontWeight: 700, color: "#ef4444", marginTop: 3 }}>PDF</span>
        </div>
      )}

      {item.type === "video" && item.duration && (
        <span style={{ position: "absolute", bottom: 6, left: 6, background: "rgba(0,0,0,0.7)", color: "#fff", fontSize: "10px", fontWeight: 600, padding: "2px 6px", borderRadius: "4px", fontVariantNumeric: "tabular-nums" }}>
          {formatDuration(item.duration)}
        </span>
      )}

      {item.type === "video" && !isSelected && (
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.1)", opacity: hovering ? 1 : 0.5, transition: "opacity 0.15s" }}>
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", paddingLeft: 2 }}>
            <Icons.Play />
          </div>
        </div>
      )}

      {isSelected && (
        <div style={{ position: "absolute", top: 6, right: 6, width: 22, height: 22, borderRadius: "50%", background: "#7c3aed", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", boxShadow: "0 1px 4px rgba(124,58,237,0.3)" }}>
          <Icons.Check />
        </div>
      )}

      {hovering && (
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(0deg, rgba(0,0,0,0.55) 0%, transparent 50%)", display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: "8px" }}>
          <span style={{ color: "#fff", fontSize: "10px", lineHeight: 1.3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", paddingRight: 24 }}>{item.name}</span>
          <span style={{ color: "rgba(255,255,255,0.65)", fontSize: "9px" }}>{formatBytes(item.size)}</span>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(item.id); }}
            style={{ position: "absolute", top: 5, right: 5, width: 24, height: 24, borderRadius: "50%", border: "none", background: "rgba(0,0,0,0.5)", color: "#ff7b7b", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <Icons.Trash />
          </button>
        </div>
      )}
    </div>
  );
}